var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResendWithdrawalConfirmationLayout',{class:_vm.containerClasses,attrs:{"email":_vm.getUserBasicInfo.email,"isLoading":_vm.isLoading},on:{"onClose":_vm.onCloseModal,"onResend":_vm.onResend}})}
var staticRenderFns = []

export { render, staticRenderFns }